import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Permission} from '../models/entities/permission';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class PermissionService {
  private apiUrl = environment.apiUrl;
  private permissions = environment.permissions;

  constructor(private http: HttpClient) {
  }

  public getAllPermissions(): Observable<Permission[]> {
    return this.http.get<Permission[]>(`${this.apiUrl}/permissions`, {});
  }

  public putPermissions(permissions) {
    localStorage.setItem(this.permissions, JSON.stringify(permissions));
  }

  public clearPermissions(){
    localStorage.removeItem(this.permissions);
  }

  public getMyPermissions(){

  }
}
